'use strict';
module.exports = require('./DataView.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/dataview/index.js
// module id = 54
// module chunks = 1